import {
  DEALERSHIP_OPTIONS,
  urduFor,
} from "../../../../Utils/staticDropdownOptions";
import { colorNameToHex } from "../utils/colorHelpers";
import { createEmptyColorRow } from "../utils/formDefaults";

function mapColorFromApi(color, variant, isSingleVariant) {
  const colorValue = color.color || "";
  let colorCodeValue = color.colorCode;
  if (!colorCodeValue && colorValue) {
    if (colorValue.match(/^#[0-9A-Fa-f]{6}$/i)) {
      colorCodeValue = colorValue.toUpperCase();
    } else {
      colorCodeValue = colorNameToHex(colorValue) || "#000000";
    }
  }

  return {
    id: color.id || null,
    name: variant.name || "",
    name_ur: variant.variantName_ur || variant.name_ur || "",
    color: colorValue,
    color_ur: color.color_ur || "",
    colorCode: colorCodeValue || "#000000",
    price: isSingleVariant
      ? variant.price || color.price || ""
      : variant.price || color.price || "",
    weight: isSingleVariant
      ? variant.weight || color.weight || ""
      : variant.weight || color.weight || "",
    dimension: isSingleVariant
      ? variant.dimension || color.dimension || ""
      : variant.dimension || color.dimension || "",
    unit: isSingleVariant
      ? variant.unit || color.unit || ""
      : variant.unit || color.unit || "",
    unit_ur: isSingleVariant
      ? variant.unit_ur || color.unit_ur || ""
      : variant.unit_ur || color.unit_ur || "",
    moq: isSingleVariant
      ? variant.moq || color.moq || ""
      : variant.moq || color.moq || "",
    position: variant.position != null ? variant.position : "",
    existingImages: Array.isArray(color.images)
      ? color.images.map((img, imgIndex) =>
          typeof img === "string"
            ? {
                url: img,
                position: imgIndex + 1,
                isPrimary: false,
              }
            : {
                url: img.imageUrl || img.url || "",
                isPrimary: !!(img.isPrimary || img.is_primary),
                position:
                  img.isPrimary || img.is_primary
                    ? ""
                    : img.displayOrder != null && Number(img.displayOrder) >= 1
                      ? img.displayOrder
                      : img.position != null && Number(img.position) >= 1
                        ? img.position
                        : imgIndex + 1,
                id: img.id || null,
                image_alt: img.image_alt || "",
                image_title: img.image_title || "",
              },
        )
      : Array.isArray(color.image)
        ? color.image.map((img, imgIndex) => ({
            url: typeof img === "string" ? img : img.imageUrl || img.url,
            position: imgIndex + 1,
            isPrimary: false,
          }))
        : [],
    newImageFiles: [],
    newImagePositions: [],
    newImageAlts: [],
    newImageTitles: [],
    newImagePrimaryIndex: null,
    existingVariantImage: variant.variant_image || color.variant_image || null,
    variantImageFile: null,
    variantImageAlt:
      variant.variant_image_alt || color.variant_image_alt || "",
    variantImageTitle:
      variant.variant_image_title || color.variant_image_title || "",
    texture: color.texture === true,
    existingTextureImage: color.texture_image || null,
    textureImageFile: null,
    textureImageAlt: color.texture_image_alt || "",
    textureImageTitle: color.texture_image_title || "",
    textureCode: color.texture_code || "",
  };
}

function mapLegacyColorFromApi(color) {
  const colorValue = color.color || "";
  let colorCodeValue = color.colorCode;
  if (!colorCodeValue && colorValue) {
    if (colorValue.match(/^#[0-9A-Fa-f]{6}$/i)) {
      colorCodeValue = colorValue.toUpperCase();
    } else {
      colorCodeValue = colorNameToHex(colorValue) || "#000000";
    }
  }

  return {
    id: color.id || null,
    name: color.name || "",
    name_ur: color.name_ur || color.variantName_ur || "",
    color: colorValue,
    color_ur: color.color_ur || "",
    colorCode: colorCodeValue || "#000000",
    price: color.price || "",
    weight: color.weight || "",
    dimension: color.dimension || "",
    unit: color.unit || "",
    moq: color.moq || "",
    existingImages: Array.isArray(color.image) ? color.image : [],
    newImageFiles: [],
    newImagePositions: [],
    newImageAlts: [],
    newImageTitles: [],
    newImagePrimaryIndex: null,
    existingVariantImage: color.variant_image || null,
    variantImageFile: null,
    variantImageAlt: color.variant_image_alt || "",
    variantImageTitle: color.variant_image_title || "",
    texture: color.texture === true,
    existingTextureImage: color.texture_image || null,
    textureImageFile: null,
    textureImageAlt: color.texture_image_alt || "",
    textureImageTitle: color.texture_image_title || "",
    textureCode: color.texture_code || "",
  };
}

export function mapProductSourceToFormData(source) {
  const isSingleVariant =
    source.singleVarinet === true ||
    (source.variants &&
      source.variants.length > 0 &&
      source.variants[0]?.name === null);

  let colorsData = [];
  let productLevelVariantFields = {
    weight: "",
    unit: "",
    unit_ur: "",
    price: "",
    dimensions: "",
    moq: "",
  };

  if (
    source.variants &&
    Array.isArray(source.variants) &&
    source.variants.length > 0
  ) {
    const firstVariant = source.variants[0];

    if (isSingleVariant) {
      productLevelVariantFields = {
        weight: firstVariant.weight || "",
        unit: firstVariant.unit || "",
        unit_ur: firstVariant.unit_ur || "",
        price: firstVariant.price || "",
        dimensions: firstVariant.dimension || "",
        moq: firstVariant.moq || "",
      };
    }

    source.variants.forEach((variant) => {
      if (variant.colors && Array.isArray(variant.colors)) {
        variant.colors.forEach((color) => {
          colorsData.push(mapColorFromApi(color, variant, isSingleVariant));
        });
      }
    });
  } else if (Array.isArray(source.colors)) {
    colorsData = source.colors.map(mapLegacyColorFromApi);
  }

  return {
    categoryIds: Array.isArray(source.categories)
      ? source.categories.map((cat) => cat.categoryId || cat.id)
      : source.category?.categoryId
        ? [source.category.categoryId]
        : [],
    name: source.name || "",
    productName_ur: source.productName_ur || "",
    customUrl: source.customUrl || "",
    description: source.description || "",
    description_ur: source.description_ur || "",
    shortDescription: source.shortDescription || "",
    shortDescription_ur: source.shortDescription_ur || "",
    status: source.status ? "true" : "false",
    colors: colorsData,
    currency: source.currency || "",
    brandId: source.brandId ? String(source.brandId) : "",
    dealership: source.dealership || "authorizedDealer",
    dealership_ur:
      source.dealership_ur ||
      urduFor(DEALERSHIP_OPTIONS, source.dealership || "authorizedDealer"),
    singleVarinet: isSingleVariant,
    technicalDataSheet: null,
    existingTechnicalDataSheet: source.technicalDataSheet || null,
    ...productLevelVariantFields,
  };
}

export function createDefaultNewProductColors() {
  return [createEmptyColorRow({ position: 1 })];
}
